import { CSSProperties } from 'react';

export const styles = {
  container: {
    padding: '20px 0',
  } as CSSProperties,

  header: {
    marginBottom: 32,
  } as CSSProperties,

  title: {
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 4,
    color: '#262626',
  } as CSSProperties,

  stepsContainer: {
    marginBottom: 40,
    backgroundColor: 'transparent',
    padding: '0',
  } as CSSProperties,

  stepContent: {
    marginBottom: 24,
    minHeight: 400,
  } as CSSProperties,

  navigationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  } as CSSProperties,
};

export const stepsStyles = `
  .laudo-wizard-steps .ant-steps {
    background-color: transparent !important;
    background: transparent !important;
    padding: 0 !important;
  }
  .laudo-wizard-steps .ant-steps-item {
    background-color: transparent !important;
  }
`;
